export const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];

export const days = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
];

export const PersonaOptions = [
    {
        key: 1,
        text: "All",
        value: "All",
    },
    {
        key: 2,
        text: "Morning",
        value: "Morning",
    },
    {
        key: 3,
        text: "Evening",
        value: "Evening",
    },
    { key: 4, text: "Custom", value: "Custom" },
];

export const sessionTiming = {
    All: {
        startTime: 0,
        endTime: 23,
    },
    Morning: {
        startTime: 9,
        endTime: 18,
    },
    Evening: {
        startTime: 18,
        endTime: 23,
    },
    Custom: {
        startTime: null,
        endTime: null,
    },
};
